/* Little Boop — custom scripts */
(function () {
  // ---------- Countdown (to a real date; hides when over) ----------
  class LbCountdown extends HTMLElement {
    connectedCallback() {
      let end;
      if (this.dataset.mode === 'visitor') {
        const key = 'lbTimerEnd', mins = parseInt(this.dataset.minutes, 10) || 168;
        let saved = null;
        try { saved = parseInt(localStorage.getItem(key), 10); } catch (e) {}
        if (!saved || isNaN(saved)) { saved = Date.now() + mins * 60000; try { localStorage.setItem(key, String(saved)); } catch (e) {} }
        end = new Date(saved);
      } else {
        end = new Date((this.dataset.end || '').replace(' ', 'T'));
      }
      if (isNaN(end)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const q = (k) => this.querySelector('[data-' + k + ']');
      const els = { d: q('d'), h: q('h'), m: q('m'), s: q('s') };
      const set = (el, v) => { if (el && el.textContent !== v) { el.textContent = v; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); } };
      const tick = () => {
        let t = Math.floor((end - new Date()) / 1000);
        if (t <= 0) { clearInterval(this.iv); const w = this.closest('.lb-countdown-wrap'); if (w) w.remove(); return; }
        set(els.h, pad(Math.floor(t / 3600))); set(els.m, pad(Math.floor((t % 3600) / 60))); set(els.s, pad(t % 60));
      };
      tick(); this.iv = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.iv); }
  }
  if (!customElements.get('lb-countdown')) customElements.define('lb-countdown', LbCountdown);

  // ---------- Bundle selector ----------
  class LbBundle extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('.lb-card')];
      const vj = this.querySelector('[data-lb-variants]');
      this.variants = vj ? JSON.parse(vj.textContent) : [];
      this.swatches = [...this.querySelectorAll('[data-lb-color]')];
      this.color = this.swatches.length ? this.swatches[0].dataset.lbColor : null;
      this.swatches.forEach((b) => b.addEventListener('click', () => {
        this.color = b.dataset.lbColor;
        this.swatches.forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
        const nm = this.querySelector('[data-lb-color-name]'); if (nm) nm.textContent = this.color;
        this.select(this.querySelector('.lb-card.is-active') || this.cards[0], false);
      }));
      this.cards.forEach((c) => {
        c.addEventListener('click', (e) => { if (e.target.closest('select')) return; this.select(c, true); });
        c.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.select(c, true); } });
      });
      if (this.dataset.mode === 'colors') this.initColors();
      this.select(this.querySelector('.lb-card.is-active') || this.cards[0], false);
      this.initSticky();
    }
    initColors() {
      this.querySelectorAll('[data-lb-pick]').forEach((pick) => {
        pick.querySelectorAll('[data-lb-vid]').forEach((b) => b.addEventListener('click', (e) => {
          e.stopPropagation();
          pick.querySelectorAll('[data-lb-vid]').forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
          const nm = pick.querySelector('[data-lb-pick-name]'); if (nm) nm.textContent = b.dataset.lbVname;
          const card = b.closest('.lb-card'); if (card && !card.classList.contains('is-active')) this.select(card, true); else this.syncForm();
        }));
      });
      const fid = this.dataset.form;
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form || !form.getAttribute || form.getAttribute('id') !== fid) return;
        const items = this.items();
        if (!items.length) return;
        e.preventDefault(); e.stopImmediatePropagation();
        const btn = form.querySelector('[name="add"]');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); btn.disabled = true; }
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
          .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
          .then(({ ok, j }) => {
            if (!ok) throw new Error(j.description || j.message || 'Could not add to cart');
            window.location.href = root + 'cart';
          })
          .catch((err) => {
            if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); btn.disabled = false; }
            const box = form.closest('product-info, .product') ? document.querySelector('.product-form__error-message') : null;
            if (box) { box.textContent = err.message; const w = box.closest('.product-form__error-message-wrapper'); if (w) w.hidden = false; } else alert(err.message);
          });
      }, true);
    }
    items() {
      const card = this.querySelector('.lb-card.is-active') || this.cards[0];
      if (!card) return [];
      const counts = {};
      card.querySelectorAll('[data-lb-pick]').forEach((p) => {
        const a = p.querySelector('[data-lb-vid].is-active') || p.querySelector('[data-lb-vid]:not([disabled])');
        if (a) counts[a.dataset.lbVid] = (counts[a.dataset.lbVid] || 0) + 1;
      });
      const bundle = card.dataset.title || '';
      return Object.keys(counts).map((id) => ({ id: Number(id), quantity: counts[id] }));
    }
    syncForm() {
      const fid = this.dataset.form, form = document.getElementById(fid);
      if (!form) return;
      const items = this.items();
      if (!items.length) return;
      document.querySelectorAll(`#${fid} input[name="id"], input[name="id"][form="${fid}"]`).forEach((i) => { i.value = items[0].id; });
      let q = form.querySelector('input[name="quantity"]');
      if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; form.appendChild(q); }
      q.value = items.reduce((n, x) => n + x.quantity, 0);
      const btn = form.querySelector('[name="add"]'); if (btn) btn.disabled = false;
    }
    select(card, anim) {
      if (!card) return;
      this.cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on);
        const r = c.querySelector('input[type=radio]'); if (r) r.checked = on;
        c.querySelectorAll('select').forEach((s) => (s.disabled = !on));
      });
      if (anim) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); }
      const fid = this.dataset.form, form = document.getElementById(fid);
      if (form) {
        if (this.dataset.mode === 'colors') {
          this.syncForm();
        } else if (this.dataset.mode === 'options') {
          const v = this.variants.find((x) => x.o1 === card.dataset.pack && (!this.color || x.o2 === this.color));
          if (v) {
            document.querySelectorAll(`#${fid} input[name="id"], input[name="id"][form="${fid}"]`).forEach((i) => { i.value = v.id; });
            const btn = form.querySelector('[name="add"]');
            if (btn) btn.disabled = !v.a;
          }
        } else if (this.dataset.mode === 'variant' && card.dataset.variant) {
          document.querySelectorAll(`#${fid} input[name="id"], input[name="id"][form="${fid}"]`).forEach((i) => { i.value = card.dataset.variant; });
          const btn = form.querySelector('[name="add"]');
          if (btn) btn.disabled = card.dataset.available !== 'true';
        } else {
          let q = form.querySelector('input[name="quantity"]');
          if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; form.appendChild(q); }
          q.value = card.dataset.qty;
        }
      }
      const st = document.querySelector('[data-lb-sticky]');
      if (st) {
        const t = st.querySelector('[data-lb-sticky-title]'), p = st.querySelector('[data-lb-sticky-price]');
        if (t) t.textContent = card.dataset.title || ''; if (p) p.textContent = card.dataset.price || '';
      }
    }
    initSticky() {
      const st = document.querySelector('[data-lb-sticky]');
      const main = document.querySelector(`#${this.dataset.form} [name="add"]`);
      if (!st || !main || !('IntersectionObserver' in window)) return;
      document.body.appendChild(st);
      const btn = st.querySelector('[data-lb-sticky-btn]');
      btn.addEventListener('click', () => { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(() => main.click(), 350); });
      let past = false;
      new IntersectionObserver(([e]) => {
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        st.classList.toggle('is-visible', past);
        st.setAttribute('aria-hidden', !past); btn.tabIndex = past ? 0 : -1;
      }, { threshold: 0 }).observe(main);
    }
  }
  if (!customElements.get('lb-bundle')) customElements.define('lb-bundle', LbBundle);

  // ---------- Review slider ----------
  class LbReviews extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.lb-rev__slide')];
      this.dots = [...this.querySelectorAll('.lb-rev__dots button')];
      this.i = 0;
      this.dots.forEach((d, n) => d.addEventListener('click', () => { this.go(n); this.restart(); }));
      this.addEventListener('mouseenter', () => clearInterval(this.iv));
      this.addEventListener('mouseleave', () => this.restart());
      this.go(0); this.restart();
    }
    go(n) { this.i = n; this.slides.forEach((s, k) => s.classList.toggle('is-active', k === n)); this.dots.forEach((d, k) => d.classList.toggle('is-active', k === n)); }
    restart() { clearInterval(this.iv); if (this.slides.length > 1) this.iv = setInterval(() => this.go((this.i + 1) % this.slides.length), 5000); }
    disconnectedCallback() { clearInterval(this.iv); }
  }
  if (!customElements.get('lb-reviews')) customElements.define('lb-reviews', LbReviews);

  // ---------- Track order ----------
  function initTrack() {
    document.querySelectorAll('[data-lb-app]').forEach((btn) => {
      const form = btn.closest('form');
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const o = form.querySelector('[data-lb-order]').value.trim().replace(/^#/, '');
        const m = form.querySelector('[data-lb-email]').value.trim();
        const u = new URL(btn.dataset.lbApp, location.origin);
        u.searchParams.set('order', o); u.searchParams.set('email', m);
        location.href = u.toString();
      });
    });
    document.querySelectorAll('[data-lb-track-num]').forEach((form) => {
      const input = form.querySelector('input'), err = form.querySelector('[data-lb-err]');
      const box = document.querySelector('[data-lb-result]'), link = document.querySelector('[data-lb-17]');
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const num = input.value.trim().replace(/\s+/g, '');
        err.hidden = !!num; if (!num) { input.focus(); return; }
        const url = 'https://t.17track.net/en#nums=' + encodeURIComponent(num);
        if (link) link.href = url;
        box.classList.add('is-open');
        const run = () => { try { window.YQV5.trackSingle({ YQ_ContainerId: 'LbYQContainer', YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num }); } catch (x) {} };
        if (window.YQV5) run();
        else { const sc = document.createElement('script'); sc.src = 'https://www.17track.net/externalcall.js'; sc.onload = run; document.head.appendChild(sc); }
        setTimeout(() => box.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
      });
    });
  }

  // ---------- Privacy choices ----------
  function initPrivacy() {
    document.querySelectorAll('[data-lb-privacy]').forEach((b) => b.addEventListener('click', () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      else location.href = b.dataset.fallback;
    }));
  }

  // ---------- Smooth anchor scroll ----------
  function initAnchors() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]'); if (!a || a.getAttribute('href').length < 2) return;
      const t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
      e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  const ready = (fn) => (document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn));
  ready(() => { initTrack(); initPrivacy(); initAnchors(); });
})();
